/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Subtitle_Export_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Subtitle export failed: {error}" |
*
* @param {Subtitle_Export_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_failed_toast = /** @type {((inputs: Subtitle_Export_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`L'exportation des sous-titres a échoué : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Untertitelexport fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Esportazione sottotitoli fallita: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка экспорта субтитров: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error en la exportación de subtítulos: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`字幕导出失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`字幕のエクスポートに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`उपशीर्षक निर्यात विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha na exportação de legendas: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Subtitle export failed: ${i?.error}`)
});